import { createSlice } from '@reduxjs/toolkit';
import { fetchWellTestId, WellTestIdResponse } from '../../dispatchers/WellTestDispatcher';

// Extended state interface to support loading and error
const initialState = {
  data: null as WellTestIdResponse | null,
  loading: false,
  error: undefined,
  lastFetchedAssetId: undefined as string | undefined,
};

const WellTestIdSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setWellTestIdInitialState: (state) => {
      state.data = null;
      state.error = undefined;
      state.loading = false;
      state.lastFetchedAssetId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder;
    builder
      .addCase(fetchWellTestId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWellTestId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetchedAssetId = action.meta.arg;
      })
      .addCase(fetchWellTestId.rejected, (state, action) => {
        state.loading = false;
        console.log('action.error.message::', action.error.message);
      });
  },
});

export const { setWellTestIdInitialState } = WellTestIdSlice.actions;

export default WellTestIdSlice.reducer;
